export enum OfferTypeEnum {
    VOL = 'vol',
    LKP = 'lkp'
}
